import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { utilService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button, Panel } from '../../../atoms'
import { EditTable } from '../../../organisms'
import SidebarLayout from '../../_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  partner_venues: any
  user: any
}

const COLUMNS = [
  {
    name: '提携先名',
    field: 'name',
  },
  {
    name: 'slug',
    field: 'slug',
  },
  {
    name: 'ログインID',
    field: 'login_id',
  },
  {
    name: '紐づけツアー',
    field: 'posts',
    renderElement: (record: interfaces.IPartnerVenue) => (
      <span>{record.posts.map(post => post.short_name || `ID:${post.id}`).join(', ')}</span>
    ),
  },
  {
    name: '公開状態',
    field: 'is_active',
    renderElement: (record: interfaces.IPartnerVenue) => (
      <span>{record.is_active ? '公開' : '停止'}</span>
    ),
  },
  {
    name: 'ゲスト名簿',
    field: 'is_guest_list_active',
    renderElement: (record: interfaces.IPartnerVenue) => (
      <span>{record.is_guest_list_active ? '公開' : '非公開'}</span>
    ),
  },
]

const AgentPartnerVenues: React.FC<IProps> = ({ partner_venues, user }) => {
  Hooks.SetDocumentTitle('Agent Partner Venues')
  const { data: userData } = utilService.getDataFromJson(user)
  const { data: partnerVenues } = utilService.getDataFromJson(partner_venues)

  const handleCopyUrl = async (slug: string) => {
    try {
      if (!window.navigator.clipboard) {
        throw new Error('clipboard API is unavailable')
      }
      await window.navigator.clipboard.writeText(`${location.origin}/partner_venues/${slug}`)
      window.flashMessages.addMessage({ text: 'URLをコピーしました', type: 'success' })
    } catch (e) {
      window.alert('コピーに失敗しました。お手数ですが手動でコピーしてください。')
    }
  }

  const renderRecordControls = (record: interfaces.IPartnerVenue) => {
    return (
      <>
        <Button key="edit" small={true}>
          <a href={`/agent/partner_venues/${record.id}/edit`}>{I18n.t('generic.edit')}</a>
        </Button>
        <Button key="copy" small={true} handleClick={() => handleCopyUrl(record.slug)}>
          URLコピー
        </Button>
      </>
    )
  }

  return (
    <SidebarLayout user={userData}>
      <Wrapper>
        <Panel
          title={
            <Heading>
              <span>{I18n.t('partner_venue', { scope: 'activerecord.models' })}</span>
              <div className="rightControls">
                <Button small={true}>
                  <a href="/agent/partner_venues/new">{I18n.t('generic.create_new')}</a>
                </Button>
              </div>
            </Heading>
          }
        >
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={partnerVenues}
            pagination={null}
            handleDelete={null}
            getEditLink={null}
            renderRecordControls={renderRecordControls}
          />
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .rightControls {
    flex: 0;
    display: flex;
    align-items: center;
    gap: 12px;
  }
`

const Wrapper = styled.div`
  width: 100%;
  padding: 22px 40px 80px 46px;

  .Panel {
    max-width: none;
  }
`

export default AgentPartnerVenues
